<template>
    <a :href="href" target="_blank" class="btn btn-success page-action" :disabled="disabled">
        <i class="fa fa-file-excel-o" /> {{ label }}
    </a>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        href: {
            type: String,
            required: false,
            default: null,
        },
        label: {
            type: String,
            required: false,
            default: 'Export Excel',
        },
    }
}
</script>